import Step from 'shepherd.js/src/types/step';
import {TourSteps} from './interface/tour-steps.interface';

export const goToScheduleStep: (tourSteps: TourSteps) => Step.StepOptions[] =
  ({steps, buttons}: TourSteps): Step.StepOptions[] => {
    return  [{
      ...steps.default,
      id: 'schedule1',
      title: 'Revisa tu agenda',
      text: `Da clic en "Mi agenda" para poder continuar.`,
      cancelIcon: {enabled: false},
      attachTo: {
        element: '.l-item-0-1',
        on: 'bottom'
      },
      advanceOn: {
        selector: '.l-item-0-1',
        event: 'click'
      },
      buttons: [
        {
          ...buttons.cancel,
        }
      ],
      beforeShowPromise: () => {
        return new Promise((resolve): void => {
          setTimeout((): void => {
            resolve(true);
          }, 1000);
        });
      },
      classes: 'shepherd shepherd-open shepherd-theme-square shepherd-transparent-text',
    }];
  };
